/**
 * Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 * All information herein, source code below as well as the Morpheus system itself and all related
 * software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 * Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 * is prohibited.
 */

import { replaceSubdomain } from '@morpheus/utils/admin-vue/helpers/api-helper'
import axios from 'axios'
import { ScriptCreateData, ScriptCreateResponseData, ScriptListData, ScriptShowData } from '../types'

const scriptBaseURL = replaceSubdomain(process.env.VUE_APP_API_SUBDOMAIN_SCRIPT)

export const scriptClient = axios.create({
  baseURL: scriptBaseURL
})

export function fetchScriptList (): Promise<ScriptListData> {
  return new Promise((resolve, reject) => {
    scriptClient.get('/')
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function fetchScriptById (id: string): Promise<ScriptShowData> {
  return new Promise((resolve, reject) => {
    scriptClient.get(`/${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function createScript (script: ScriptCreateData): Promise<ScriptCreateResponseData> {
  return new Promise((resolve, reject) => {
    scriptClient.post(`/`, script)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function publishScript (version: string): Promise<any> {
  return new Promise((resolve, reject) => {
    scriptClient.put(`/publish/${version}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export default {
  fetchScriptList,
  fetchScriptById,
  createScript,
  publishScript
}
